<template>
  <AuthLayout :wait-for-brand-panel="false" data-testid="sso-callback">
    <AuthLoginLogo />
    <div class="sso-callback__body">
      <v-progress-circular
        v-if="!error"
        indeterminate
        color="primary"
        class="sso-callback__spinner"
        data-testid="sso-callback__spinner"
      />
      <AuthLoginAlert
        :message="error"
        test-id="sso-callback__alert"
      />
      <p
        v-if="!error"
        class="sso-callback__status"
        data-testid="sso-callback__status"
      >
        {{ copy.SSO_CALLBACK_SIGNING_IN }}
      </p>
      <v-btn
        v-if="error"
        class="sso-callback__primary"
        color="primary"
        block
        large
        elevation="0"
        data-testid="sso-callback__back-to-login"
        @click="goLogin"
      >
        <span>{{ copy.SSO_CALLBACK_BACK }}</span>
      </v-btn>
    </div>
  </AuthLayout>
</template>

<script>
import constants from '../../plugins/constants';
import AuthLayout from './components/AuthLayout.vue';
import AuthLoginAlert from './components/AuthLoginAlert.vue';
import AuthLoginLogo from './components/AuthLoginLogo.vue';

const { AUTH } = constants;

export default {
  name: 'SsoCallback',
  components: {
    AuthLayout,
    AuthLoginAlert,
    AuthLoginLogo,
  },
  data: () => ({
    error: '',
    started: false,
    copy: AUTH,
  }),
  created() {
    this.completeSignIn();
  },
  beforeDestroy() {
    this.error = '';
    this.started = false;
  },
  methods: {
    goLogin() {
      this.$router.replace('/');
    },
    async completeSignIn() {
      if (this.started) return;
      this.started = true;

      const code = String(this.$route.query.code || '').trim();
      const state = String(this.$route.query.state || '').trim();
      if (!code || !state) {
        console.error({
          message: 'SSO exchange complete',
          meta: { success: false },
        });
        this.error = this.copy.SSO_CALLBACK_GENERIC_ERROR;
        return;
      }

      try {
        await this.$store.dispatch('auth/completeSso', { code, state });
        let returnPath = '/';
        try {
          const stored = sessionStorage.getItem(
            constants.STORAGE_KEYS.POST_LOGIN_RETURN_PATH,
          );
          if (stored) {
            returnPath = stored;
            sessionStorage.removeItem(constants.STORAGE_KEYS.POST_LOGIN_RETURN_PATH);
          }
        } catch (_) { /* storage unavailable */ }
        window.location.assign(returnPath);
      } catch (err) {
        this.error =
          this.$store.state.auth.errorMessage ||
          err?.response?.data?.message ||
          err?.message ||
          this.copy.SSO_CALLBACK_GENERIC_ERROR;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './SsoCallback.scss';
</style>
